import { createContext, useContext } from 'react'

import { useAuth } from '../../Shared/Contexts/AuthContext'

const DevicesContext = createContext({})

export const useDevices = () => {
  return useContext(DevicesContext)
}

export const DevicesProvider = ({ children }) => {
  const { useBaseAxiosPost } = useAuth()

  const useFetchDevices = async (page) => {
    return await useBaseAxiosPost({ url: '/devices/search', payload: { allowMissingPosition: true, searchInSubOrganizations: false }, params: { page: page, pageSize: 99999999 } })
  }

  const value = {
    useFetchDevices
  }

  return (
    <DevicesContext.Provider value={value}>{children}</DevicesContext.Provider>
  )
}
